import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLDRAGONFLYDOJI', label: 'Dragonfly Doji', lookback: 10 })
